import {TabPanel, TabView} from "primereact/tabview";
import {useTranslation} from "react-i18next";
import React from "react";
import ItemTablePricing from "./ItemTablePricing";
import {Button} from "primereact/button";
import {onChangeModalSubscription} from "../../redux/actions/ActionApp";
import {useDispatch} from "react-redux";

export default function TablePricing(props) {

    const { t } = useTranslation();
    const { isHome, myContext} = props;
    const dispatch = useDispatch();
    const onCloseModal = (dispatch) => {
        dispatch(onChangeModalSubscription());
    }

    return(
        <div className={`table_pricing ${isHome ? 'home' : 'modal'}`}>
            <TabView>
                <TabPanel header={t('PLAN_MODAL.HEADER_TAB')}>
                    <div className="pricing__container">
                        <ItemTablePricing isHome={isHome} myContext={myContext} type={'FREE'} time={'MONTH'} />
                        <ItemTablePricing isHome={isHome} myContext={myContext} type={'ADVANCED'} time={'MONTH'} />
                        <ItemTablePricing isHome={isHome} myContext={myContext} type={'PROFESSIONAL'} time={'MONTH'} />
                        <ItemTablePricing isHome={isHome} myContext={myContext} type={'FULL_ACCESS'} time={'MONTH'} />
                    </div>
                </TabPanel>
                <TabPanel header={t('PLAN_MODAL.HEADER_TAB_YEAR')}>
                    <div className="pricing__container">
                        <ItemTablePricing isHome={isHome} myContext={myContext} type={'FREE'} time={'YEAR'} />
                        <ItemTablePricing isHome={isHome} myContext={myContext} type={'ADVANCED'} time={'YEAR'} />
                        <ItemTablePricing isHome={isHome} myContext={myContext} type={'PROFESSIONAL'} time={'YEAR'} />
                        <ItemTablePricing isHome={isHome} myContext={myContext} type={'FULL_ACCESS'} time={'YEAR'} />
                    </div>
                </TabPanel>
            </TabView>

            {
                myContext && myContext.user?.subscription_type === "Trial" ?
                    <div className="plans trial">
                        <Button  onClick={() => onCloseModal(dispatch)}  className="p-button-sm p-button-outlined p-button-info">{t('PLAN_MODAL.BUTTON_SKIP_PAYMENT')}</Button>
                    </div>
                    :
                    <></>
            }
        </div>
    )
}